(() => {
	const faqQuestions = document.querySelectorAll('.faq__question');

	[...faqQuestions].forEach(faq => {
		const faqItem = faq.closest('.faq__item');
		faq.addEventListener('click', function(e) {
			e.preventDefault();
			toggleFaq(faqItem);
		});
	});

	const toggleFaq = faqItem => {
		const questionPanel = faqItem.querySelector('.faq__content');
		const isOpened = faqItem.classList.contains('faq__item--opened');
		if(isOpened) {
			closeFaq(faqItem, questionPanel);
		} else {
			openFaq(faqItem, questionPanel);
		}
	};

	const openFaq = (faqItem, questionPanel) => {
		faqItem.classList.add('faq__item--opened');
		faqItem.setAttribute('aria-expanded', 'true');
		questionPanel.style.maxHeight = questionPanel.scrollHeight + 'px';
	};

	const closeFaq = (faqItem, questionPanel) => {
		faqItem.classList.remove('faq__item--opened');
		faqItem.setAttribute('aria-expanded', 'false');
		questionPanel.style.maxHeight = null;
	};
})();